//libs
import { useEffect, useState, useCallback } from 'react';
export interface FomoTagDetail {
  end_time: number;
  label: string;
}

const MS_IN_SECOND = 1000;
const MS_IN_MINUTE = MS_IN_SECOND * 60;
const MS_IN_HOUR = MS_IN_MINUTE * 60;
const MS_IN_DAY = MS_IN_HOUR * 24;

const twoDigitValues = (value: number, suffix: string) => {
  if (value <= 0 && (suffix === 'h: ' || suffix === 'd: ')) return '';
  return ('0' + value).slice(-2) + suffix;
};

export interface LocationConfig {
  enable: boolean;
  fomoBackgroundColor: string;
  textColor: string;
  clockColor: string;
  timerColor: string;
}

interface FomoTimerProps {
  initTime: number;
  showDays: boolean;
  setIsExpired: (isExpired: boolean) => void;
}

export default function useTimer({ initTime, showDays, setIsExpired }: FomoTimerProps) {
  // time to come from the top depending upon the component
  const saleTimeEpoch = initTime * 1000;
  const currentTimeEpoch = new Date();
  const timeDifference = saleTimeEpoch - currentTimeEpoch;

  const [timeRemaining, setTimeRemaining] = useState(timeDifference);

  const formatTimer = useCallback(
    (timeInMS: number) => {
      // days = timeInMS / Total Ms in day
      const daysValue = Math.floor(timeInMS / MS_IN_DAY);
      // hours = (remainder of timeInMS divided by number of days in ms removed  )/ Total Ms in day
      const hoursValue = Math.floor((timeInMS % MS_IN_DAY) / MS_IN_HOUR);
      // minutes = (remainder of timeInMS divided by number of ms in a minutes removed  )/ Total Ms in minute
      const minutesValue = Math.floor((timeInMS % MS_IN_HOUR) / MS_IN_MINUTE);
      // seconds = (remainder of timeInMS divided by number of ms in a seconds removed  )/ Total Ms in a second
      const secondsValue = Math.floor((timeInMS % MS_IN_MINUTE) / MS_IN_SECOND);

      return (
        (showDays ? (daysValue <= 0 ? '' : twoDigitValues(daysValue, 'd: ')) : '') +
        twoDigitValues(hoursValue, 'h: ') +
        (hoursValue <= 0 && minutesValue <= 0 ? '' : twoDigitValues(minutesValue, 'm: ')) +
        (hoursValue < 0 && minutesValue < 0 ? '' : twoDigitValues(secondsValue, 's'))
      );
    },
    [showDays]
  );

  useEffect(() => {
    if (timeDifference < 0) {
      setIsExpired && setIsExpired(true);
      return;
    }
    const timerInterval = setInterval(() => {
      setTimeRemaining((prevState) => {
        return prevState - MS_IN_SECOND;
      });
    }, MS_IN_SECOND);
    return () => clearInterval(timerInterval);
  }, [setIsExpired, timeDifference]);

  return {
    timeRemaining: formatTimer(timeRemaining),
  };
}
